<template>
    <div>
        <h2 slot="header">
            Calculations
        </h2>

        <div class="a-table a-table--short-no-style a-table--full-width">
            <table cellspacing="0" cellpadding="0" class="a-table--full-width">
                <thead>
                <tr>
                    <th>From</th>
                    <th>To</th>
                    <th>Duration (years)</th>
                    <th>Pre-Accident<br>Annual Income</th>
                    <th>Post Accident<br>Annual Income</th>
                    <th>Total Payments</th>
                    <th>Formula</th>
                    <th>Period Net Loss</th>
                </tr>
                </thead>
                <tbody>
                    <tr v-for="(period, index) in getPostInjuryIncomePeriods">
                        <td>{{ period.startOfPeriod }}</td>
                        <td>{{ period.endOfPeriod }}</td>
                        <td>{{ periodDuration(period).toFixed(2) }}</td>
                        <td>{{ currencyFormat(getPreAccidentNetTotal) }}</td>
                        <td>{{ currencyFormat(period.totalNetIncome) }}</td>
                        <td>{{ currencyFormat(periodPaymentsTotal(index)) }}</td>
                        <td>({{ currencyFormat(getPreAccidentNetTotal) }} x {{ periodDuration(period).toFixed(2) }}) -
                            ({{ currencyFormat(period.totalNetIncome) }} x {{ periodDuration(period).toFixed(2) }}) -
                            {{ currencyFormat(periodPaymentsTotal(index)) }}</td>
                        <td>{{ currencyFormat(periodNetLoss(period, index)) }}</td>
                    </tr>
                </tbody>
                <tfoot>
                <tr class="a-table--grey">
                    <td class="u-text-right u-bold" colspan="7">
                        Total Net Loss
                    </td>
                    <td>
                        <strong>
                            {{ currencyFormat(totalNetLoss()) }}
                        </strong>
                    </td>
                </tr>
                </tfoot>
            </table>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {setStepValid} from 'services/routingMethods';
    import TwoDecimalPlaces from 'directives/TwoDecimalPlaces';
    import moment from 'moment';
    import currencyFormat from 'mixins/currencyFormat';

    export default {
        name: 'past-loss-of-earnings-calculator',
        components: {
        },
        mixins: [
            currencyFormat
        ],
        directives: {
            'two-dp': TwoDecimalPlaces
        },
        computed: {
            ...mapGetters('personal/claimant', [
                'getPostInjuryIncomePeriods',
                'getPreAccidentNetTotal',
                'getPostInjuryIncomePeriodPayments'
            ]),
        },
        methods: {
            ...mapActions('personal/claimant', [
                'updateIncomeValue'
            ]),
            periodPaymentsTotal(index) {
                return this.postInjuryIncomePeriodPayments(index)
                    .reduce((total, carry) => total + carry.total ,0);
            },
            postInjuryIncomePeriodPayments(index) {
                return this.getPostInjuryIncomePeriodPayments({index: index});
            },
            periodDuration(period) {
                return moment(period.endOfPeriod, 'DD/MM/YYYY')
                    .diff(moment(period.startOfPeriod, 'DD/MM/YYYY'), 'years', true)
            },
            periodNetLoss(period, index) {
                let duration = this.periodDuration(period);
                let preAccidentIncome = this.getPreAccidentNetTotal;
                let postAccidentIncome = period.totalNetIncome;
                let periodPayments = this.periodPaymentsTotal(index);

                return (parseFloat(duration.toFixed(2)) * preAccidentIncome)
                    - (parseFloat(duration.toFixed(2)) * postAccidentIncome)
                    - periodPayments;
            },
            totalNetLoss() {
                let periods = this.getPostInjuryIncomePeriods.map((period, index) => {
                    return parseFloat(this.periodNetLoss(period, index).toFixed(2));
                });

                let total = periods.reduce((total, carry) => total + carry ,0);
                this.updateIncomeValue({key:'pastLossOfEarningsNetTotal', value: total});
                return total;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// PastLossOfEarningsCalculations.vue?880ca05c